import { render, staticRenderFns } from "./homepage-hero.vue?vue&type=template&id=05cc6a54&"
import script from "./homepage-hero.vue?vue&type=script&lang=js&"
export * from "./homepage-hero.vue?vue&type=script&lang=js&"
import style0 from "./homepage-hero.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LnCustomButton: require('/usr/src/app/components/ln-custom-button.vue').default,TrustpilotStars: require('/usr/src/app/components/common-sections/trustpilot-stars.vue').default,HeroDoc: require('/usr/src/app/components/homepage/hero-doc.vue').default})
